import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

export interface BillingBreakdownLine {
  label: string;
  quantity: number;
  rate: number;
  amount: number;
}

interface BillingBreakdownDisplayProps {
  lines: BillingBreakdownLine[];
  totalAmount: number;
  title?: string;
}

const BillingBreakdownDisplay: React.FC<BillingBreakdownDisplayProps> = ({
  lines,
  totalAmount,
  title = 'Billing Calculation',
}) => {
  if (!lines.length) return null;

  return (
    <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {title}
      </Typography>
      {lines.map((line, index) => (
        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}>
          <Typography variant="body2">
            {line.label}: {line.quantity.toLocaleString()} × ${Number(line.rate).toFixed(2)}
          </Typography>
          <Typography variant="body2">${Number(line.amount).toFixed(2)}</Typography>
        </Box>
      ))}
      <Divider sx={{ my: 1 }} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2" fontWeight="bold">Total</Typography>
        <Typography variant="body2" fontWeight="bold">${Number(totalAmount).toFixed(2)}</Typography>
      </Box>
    </Box>
  );
};

export default BillingBreakdownDisplay;
